<template>
  <el-dialog title="Novo Cliente" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="70%" v-loading="loading">
    <el-row :gutter="10" style="height: 100%">
      <el-col :span="24" style="height: 100%">
        <div style="height: 100%">
          <div style="padding: 2px;">
            <el-form ref="form" :model="cliente" :rules="validacao" size="small" label-position="top" hide-required-asterisk :show-message="false">
              <!-- Informações Básicas -->
              <div style="text-align: left; color: #1D1E1F; font-size: 16px;">
                <i class="el-icon-document"></i>
                Informações Básicas
              </div>
              <div style="padding: 10px 10px; margin: 5px -5px 10px -5px;" class="form-div">
                <el-row :gutter="24">
                  <el-col :xs="8" :lg="3" :xl="3">
                    <el-form-item label="ID">
                      <el-input auto-complete="off" v-model="cliente.idNaImobiliaria"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="16" :lg="13" :xl="13">
                    <el-form-item label="Tipo">
                      <el-radio-group v-model="cliente.personalidadeJuridica">
                        <el-radio label="PESSOA_FISICA">Pessoa Física</el-radio>
                        <el-radio label="PESSOA_JURIDICA">Pessoa Jurídica</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :lg="16" :xl="16">
                    <el-form-item label="Nome/Razão Social" prop="nome">
                      <el-input auto-complete="off" v-model="cliente.nome"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="(exibirCamposPessoaFisica ? 12 : 24)" :lg="(exibirCamposPessoaFisica ? 8 : 16)">
                    <el-form-item prop="cpfCnpj" label="CPF/CNPJ">
                      <el-input
                        auto-complete="off"
                        v-model="cliente.cpfCnpj"
                        v-mask="maskCpfCnpj" 
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="8" v-if="exibirCamposPessoaFisica">
                    <el-form-item label="RG">
                      <el-input auto-complete="off" v-model="cliente.rg"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24" v-if="exibirCamposPessoaFisica">
                  <el-col :xs="24" :lg="5">
                    <el-form-item label="Data de Nascimento">
                      <el-date-picker
                        auto-complete="off"
                        v-model="cliente.dataNascimento"
                        v-mask="'##/##/####'"
                        type="date"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="5">
                    <el-form-item label="Estado Civil">
                      <el-select
                        v-model="cliente.estadoCivil"
                        value-key="data"
                        placeholder
                        filterable
                        default-first-option
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in estadoCivil"
                          :key="item.data"
                          :label="item.label"
                          :value="item.data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="7">
                    <el-form-item label="Sexo">
                      <el-radio-group v-model="cliente.sexo">
                        <el-radio label="MASCULINO">Masculino</el-radio>
                        <el-radio label="FEMININO">Feminino</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24" v-if="exibirCamposPessoaFisica">
                  <el-col :xs="12" :lg="6">
                    <el-form-item label="Nacionalidade">
                      <el-input auto-complete="off" v-model="cliente.nacionalidade"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="6">
                    <el-form-item label="Profissão">
                      <el-input auto-complete="off" v-model="cliente.profissao"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="24" :lg="4">
                    <el-form-item label="Renda">
                      <div class="el-input el-input--small">
                        <money v-model="cliente.rendaMensal" v-bind="money" class="el-input__inner"/>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="12" :lg="8">
                    <el-form-item label="Celular" prop="celular">
                      <el-input
                        auto-complete="off"
                        v-model="cliente.celular"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="8">
                    <el-form-item label="Telefone" prop="telefone">
                      <el-input
                        auto-complete="off"
                        v-model="cliente.telefone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :lg="16">
                    <el-form-item label="E-mail">
                      <el-input auto-complete="off" v-model="cliente.email"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :lg="16">
                    <el-form-item label="Atendente" style="width: 100%">
                      <el-select
                        v-model="cliente.usuario"
                        :remote-method="filtrarUsuariosSelect"
                        :loading="loadingUsuarios"
                        @focus="filtrarUsuariosSelect"
                        value-key="id"
                        placeholder
                        loading-text="Carregando usuários"
                        no-data-text="Nenhum usuário encontrado"
                        filterable
                        remote
                        reserve-keyword
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in usuariosDisponiveis"
                          :key="item.id"
                          :label="item.nome"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- Conjuge -->
              <div style="text-align: left; color: #1D1E1F; font-size: 16px;" v-if="exibirInformacoesConjuge">
                <i class="el-icon-user"></i>
                Informações do Cônjuge
              </div>
              <div style="padding: 15px 15px; margin: 5px -5px 10px -5px;" v-if="exibirInformacoesConjuge" class="form-div">

                <el-row :gutter="10"> 
                  <el-col :span="24">
                    <el-form-item label="Nome" prop="nomeConjuge">
                      <el-input v-model="cliente.nomeConjuge"/>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="CPF" prop="cpf">
                      <el-input v-model="cliente.cpfConjuge" v-mask="['###.###.###-##']"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="RG">
                      <el-input v-model="cliente.rgConjuge"/>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item label="E-mail">
                      <el-input v-model="cliente.emailConjuge" />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="Profissão">
                      <el-input v-model="cliente.profissaoConjuge"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="Nacionalidade">
                      <el-input v-model="cliente.nacionalidadeConjuge"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- Endereço Principal -->
              <div style="text-align: left; color: #1D1E1F; font-size: 16px;">
                <i class="el-icon-s-home"></i>
                Endereço Principal
              </div>
              <div
                style="padding: 15px 15px; margin: 5px -5px 10px -5px;" class="form-div"
              >
                <el-row :gutter="24">
                  <el-col :xs="16" :lg="13">
                    <el-form-item label="Endereço" prop="endereco">
                      <el-input auto-complete="off" v-model="cliente.endereco"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="8" :lg="3">
                    <el-form-item label="Número">
                      <el-input auto-complete="off" v-model="cliente.numeroEndereco"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="12" :lg="12">
                    <el-form-item label="Complemento">
                      <el-input auto-complete="off" v-model="cliente.complemento"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="4">
                    <el-form-item label="CEP">
                      <el-input auto-complete="off" v-model="cliente.cep" v-mask="'#####-###'"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="12" :lg="3">
                    <el-form-item label="Estado" prop="estado">
                      <el-select
                        v-model="cliente.estado"
                        value-key="id"
                        placeholder
                        filterable
                        default-first-option
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in estados"
                          :key="item.id"
                          :label="item.sigla"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :lg="5">
                    <el-form-item label="Cidade">
                      <el-input auto-complete="off" v-model="cliente.cidade"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="20" :lg="8">
                    <el-form-item label="Bairro">
                      <el-input auto-complete="off" v-model="cliente.bairro"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- Representantes -->
              <div
                style="text-align: left; color: #1D1E1F; font-size: 16px;"
                v-if="exibirCamposPessoaJuridica"
              ><i class="el-icon-s-custom"></i> Representantes</div>
              <div
                style="padding: 15px 15px; margin: 5px -10px 10px -10px;"
                v-if="exibirCamposPessoaJuridica"
                class="form-div"
              >
                <el-row style="height: 120px; padding-top: 5px;">
                  <el-col :span="24" style="height: 100%;">
                    <el-table
                      :data="cliente.representantes"
                      empty-text="Nenhum representante cadastrado"
                      height="100%"
                      size="small"
                      style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                      stripe
                      highlight-current-row
                    >
                      <el-table-column label="Nome" prop="nome"/>
                      <el-table-column label="CPF" prop="cpf"/>
                      <el-table-column label="RG" prop="rg"/>
                      <el-table-column label="Profissão" prop="profissao"/>
                      <el-table-column label="Nacionalidade" prop="nacionalidade"/>
                      <el-table-column width="90" column-key="acoes">
                        <template slot-scope="scope">
                          <el-button
                            @click.native.prevent="removerRepresentante(scope.row)"
                            type="text"
                            size="small"
                            style="padding: 0px; color: #F56C6C;"
                          >Remover</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>

                <el-row :gutter="10" style="display: flex; flex-direction: row-reverse;">
                  <el-col :span="6">
                    <el-form-item style="width: 100%; padding-top: 10px;">
                      <el-button
                        @click="exibirGravarRepresentanteDialog()"
                        type="success"
                        size="small"
                        style="width: 100%"
                        round
                        class="btn-box-shadow"
                      >Adicionar</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="primary" size="small" round>Gravar</el-button>
    </span>

    <app-gravar-representante-dialog @close="fecharGravarRepresentanteDialog" :visibility="visibilidadeGravarRepresentanteDialog"/>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from "vuex";
import { Money } from "v-money";

import AppGravarRepresentanteDialog from "./GravarRepresentanteDialog.vue";

import URLS from '../../util/urls.js';
import { ESTADOS, ESTADO_CIVIL, CATEGORIA_CLIENTE } from "../../util/constantes.js";

export default {
  components: {
    AppGravarRepresentanteDialog,
    Money
  },
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      validacao: {
        nome: [{ required: true }],
        celular: [{ required: true, validator: this.validadorTelefoneCelular }],
        nomeConjuge: [{ required: true }]
      },
      cliente: {
        id: 0,
        personalidadeJuridica: "PESSOA_FISICA",
        sexo: "MASCULINO",
        usuario: { id: 0 },
        estado: { id: 0 },
        representantes: [],
        perfis: []
      },
      loadingUsuarios: false,
      visibilidadeGravarRepresentanteDialog: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
    };
  },
  computed: {
    ...mapState("vendasContratosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      }
    }),
    exibirCamposPessoaFisica() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA";
    },
    exibirCamposPessoaJuridica() {
      return this.cliente.personalidadeJuridica == "PESSOA_JURIDICA";
    },
    exibirBotaoGravarCliente() {
      return (
        (this.permissoes.cadastro &&
          this.cliente.id == 0 &&
          this.tabSelecionada == "detalhes") ||
        (this.permissoes.alteracao &&
          this.cliente.id != 0 &&
          this.tabSelecionada == "detalhes")
      );
    },
    estados() {
      return ESTADOS.filter(estado => { return estado.pais.id === 1 });
    },
    estadoCivil() {
      return ESTADO_CIVIL;
    },
    categoriaCliente() {
      return CATEGORIA_CLIENTE;
    },
    // UTIL
    maskCpfCnpj() {
        if(this.cliente.personalidadeJuridica === 'PESSOA_FISICA'){
            return '###.###.###-##'
        } else {
            return '##.###.###/####-##'
        }
    },
    loading() {
      return this.$store.state.loading;
    },

    exibirInformacoesConjuge() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA" && ['CASADO', 'UNIAO_ESTAVEL'].includes(this.cliente.estadoCivil);
    },

    isPessoaFisica() {
      return this.cliente.personalidadeJuridica == 'PESSOA_FISICA'
    },

    isPessoaJuridica() {
      return this.cliente.personalidadeJuridica == 'PESSOA_JURIDICA'
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),

    // ALUGUEL
    ...mapActions("alugueisContratosStore", ["gravarClienteNovoAluguel","gravarFiadorNovoAluguel"]),
    ...mapActions("alugueisImoveisStore", {gravarClienteNovoImovelAluguel: "gravarClienteNovoImovel"}),

    // VENDA
    ...mapActions("vendasContratosStore", ["gravarClienteNovoVenda", "listarUsuarios"]),
    ...mapActions("vendasImoveisStore", ["gravarClienteNovoImovel"]),

    validadorTelefoneCelular(rule, value, callback) {
      if(value) {
        return callback();
      }
      if(this.cliente.telefone) {
        return callback();
      }
      return callback(new Error());
    },

    getPayloadGravarCliente() {
      if(this.isPessoaFisica) return this.getPayloadGravarClientePessoaFisica();
      if(this.isPessoaJuridica) return this.getPayloadGravarClientePessoaJuridica();
    },

    getPayloadGravarClientePessoaFisica() {
      return {
        id: this.cliente.id,
        imobiliaria: this.cliente.imobiliaria,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        rg: this.cliente.rg,
        dataNascimento: this.cliente.dataNascimento,
        estadoCivil: this.cliente.estadoCivil,
        sexo: this.cliente.sexo,
        nacionalidade: this.cliente.nacionalidade,
        profissao: this.cliente.profissao,
        rendaMensal: this.cliente.rendaMensal,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        nomeConjuge: this.cliente.nomeConjuge,
        cpfConjuge: this.cliente.cpfConjuge,
        rgConjuge: this.cliente.rgConjuge,
        emailConjuge: this.cliente.emailConjuge,
        profissaoConjuge: this.cliente.profissaoConjuge,
        nacionalidadeConjuge: this.cliente.nacionalidadeConjuge,
      };
    },

    getPayloadGravarClientePessoaJuridica() {
      return {
        id: this.cliente.id,
        versao: this.cliente.versao,
        imobiliaria: this.cliente.imobiliaria,
        extratoRendimentoPortalCliente: this.cliente.extratoRendimentoPortalCliente,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        representantes: this.cliente.representantes,
      };
    },

    gravarHandler() {
      this.$refs["form"].validate(valid => {
        if (valid && this.cliente.personalidadeJuridica == "PESSOA_FISICA") {
          this.gravar();
        } else if (
          valid &&
          this.cliente.personalidadeJuridica == "PESSOA_JURIDICA" &&
          this.cliente.representantes.length > 0
        ) {
          this.gravar();
        } else {
          if (
            valid &&
            this.cliente.personalidadeJuridica == "PESSOA_JURIDICA" &&
            this.cliente.representantes.length == 0
          ) {
            this.exibirAlert(
              "Atenção",
              "Você deve cadastrar ao menos um representante da pessoa jurídica"
            );
          } else {
            this.exibirAlert(
              "Atenção",
              "Preencha todos os campos obrigatórios"
            );
          }
        }
      });
    },
    gravar(context) {
      const payload = this.getPayloadGravarCliente();
      if (this.tipo == "IMOVEL") {
        this.showLoading();
        this.gravarClienteNovoImovel(payload)
          .then(resultado => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }

      if (this.tipo == "ALUGUEL") {
        this.showLoading();
        this.gravarClienteNovoAluguel(payload)
          .then(resultado => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }

      if (this.tipo == "IMOVEL_ALUGUEL") {
        this.showLoading();
        this.gravarClienteNovoImovelAluguel(payload)
          .then(resultado => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.concluir(resultado.item);
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }

      if (this.tipo == "ALUGUEL_FIADOR") {
        this.showLoading();
        this.gravarFiadorNovoAluguel(payload)
          .then(resultado => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.concluir(resultado.item);
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }

      if (this.tipo == "VENDA") {
        this.showLoading();
        this.gravarClienteNovoVenda(payload)
          .then(resultado => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }

      if (this.tipo == "VISITA") {
        this.showLoading();
        return axios
          .post(URLS.CLIENTES_GRAVAR, payload)
          .then(response => {
            this.hideLoading();
            switch (response.data.status) {
              case "SUCESSO":
                this.$message.success(response.data.mensagem);
                this.concluir(response.data.item);
                break;
              case "FALHA":
                this.$message.warning(response.data.mensagem);
                break;
              case "ERRO":
                this.$message.error(response.data.mensagem);
                break;
              case "SESSAO_EXPIRADA":
                return context
                  .dispatch("loginStore/relogar", {}, { root: true })
                  .then(authResponse => {
                    if (authResponse.status == "SUCESSO") {
                      return context.dispatch("gravar");
                    }
                  })
                  .catch(error => {
                    throw error;
                  });
              default:
                return response.data;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se com o servidor");
          });
      }
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerRepresentante(representante) {
      this.cliente.representantes = this.cliente.representantes.filter(
        elemento => {
          return elemento != representante;
        }
      );
    },
    exibirGravarRepresentanteDialog() {
      this.visibilidadeGravarRepresentanteDialog = true;
    },
    fecharGravarRepresentanteDialog(args) {
      if (args.representante) {
        this.cliente.representantes.push(args.representante);
      }
      this.visibilidadeGravarRepresentanteDialog = false;
    },
    reset() {
      this.cliente = {
        id: 0,
        personalidadeJuridica: "PESSOA_FISICA",
        sexo: "MASCULINO",
        usuario: { id: 0 },
        estado: { id: 0 },
        representantes: [],
        perfis: []
      };
    },
    concluir(cliente) {
      this.reset();
      this.$emit("close", cliente);
    },
    fechar() {
      this.reset();
      this.$emit("close");
    }
  }
};
</script>

